import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { GatewayService } from 'src/app/gateway.service';
import { LocalSaveService } from 'src/app/services/local-save-service.service';

@Component({
  selector: 'app-comentario-dialog',
  templateUrl: './comentario-dialog.component.html',
  styleUrls: ['./comentario-dialog.component.scss']
})
export class ComentarioDialogComponent implements OnInit {

  idcita: number;
  comentarioTexto: string = '';
  guardando: boolean = false;
  usuario: string = '';

  constructor(
    public dialogRef: MatDialogRef<ComentarioDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private gateway: GatewayService,
    private localSave: LocalSaveService,
    private snackbar: MatSnackBar
  ) {
    this.idcita = data.idcita;
  }

  ngOnInit() {
    const usuarioData = this.localSave.get('usuarioPGV');
    this.usuario = usuarioData ? (usuarioData.nombre || usuarioData.NOMBRE || '') : '';
  }

  guardar(): void {
    if (!this.comentarioTexto || !this.comentarioTexto.trim()) {
      this.snackbar.open('El comentario no puede estar vacio', 'Cerrar', { duration: 3000 });
      return;
    }

    this.guardando = true;
    this.gateway.get('guardarcomentariobitacora', {
      IDCITA: this.idcita,
      COMENTARIO: this.comentarioTexto.trim(),
      USUARIO: this.usuario
    }).then((res: any) => {
      this.guardando = false;
      this.snackbar.open('Comentario guardado exitosamente', 'Cerrar', { duration: 2000 });
      this.dialogRef.close(true);
    }).catch(err => {
      this.guardando = false;
      // Error handled silently
      this.snackbar.open('Error al guardar el comentario', 'Cerrar', { duration: 3000 });
    });
  }

  cancelar(): void {
    this.dialogRef.close(false);
  }
}
